import { useRouter } from 'vue-router';

export default function useScrollHelper() {
  const router = useRouter();

  const smoothScroll = async (id) => {
    await router.push({ hash: `#${id}`, path: '/' });

    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      top: 0
    });
  };

  return {
    smoothScroll
  };
}
